<template>
  <div class="utility__language">
    <p class="language__current" @mouseup="showLanguageDropDownList" @touchend.prevent="showLanguageDropDownList">
      <span class="current__text">{{ currentLanguageText }}</span>
      <img src="@/assets/images/icon-caret-up-white.svg" alt="다국어 선택 아이콘" />
    </p>

    <ul v-show="isShown" class="language__ul list-style-none">
      <li
        v-for="(option, index) in languageDropDownList"
        :key="index"
        @mouseup="handleLanguageClick(option.value)"
        @touchend.prevent="handleLanguageClick(option.value)"
      >
        <span class="current__text">{{ option.text }}</span>
      </li>
      <li @mouseup="isShown = false" @touchend.prevent="isShown = false">
        <span class="current__text">{{ currentLanguageText }}</span>
        <img src="@/assets/images/icon-caret-up-red.svg" alt="다국어 선택 아이콘" />
      </li>
    </ul>

    <div
      v-if="isShown"
      class="language__backdrop"
      @mouseup="hideLanguageDropDownList"
      @touchend.prevent="hideLanguageDropDownList"
    ></div>
  </div>
</template>

<script setup lang="ts">
  import { LocaleLanguage } from '@/enums/LocaleLanguage';
  import { useConfigStore } from '@/stores/config';
  import { computed, ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  const i18n = useI18n();
  const configStore = useConfigStore();

  // 언어 리스트 초기값
  const languages = [
    { value: LocaleLanguage.Ko, text: 'KOR' },
    { value: LocaleLanguage.En, text: 'ENG' },
    { value: LocaleLanguage.Ja, text: '日本語' },
    { value: LocaleLanguage.Zh, text: '中文' },
  ];

  if (configStore.config.CultureName === 'vi-VN') {
    languages.push({ value: LocaleLanguage.Vi, text: 'Tiếng Việt' });
  }

  // 언어 리스트 show/hide
  const isShown = ref(false);

  // 선택된 언어 텍스트
  const currentLanguageText = computed(() => {
    return languages.find((item) => item.value === i18n.locale.value)?.text || 'KOR';
  });

  // 언어 리스트
  const languageDropDownList = computed(() => {
    return (
      languages.filter((item) => {
        return item.value !== i18n.locale.value;
      }) || []
    );
  });

  /** 언어 드랍다운리스트 열기 */
  const showLanguageDropDownList = () => {
    isShown.value = true;
  };

  /** 언어 드랍다운리스트 닫기 */
  const hideLanguageDropDownList = () => {
    isShown.value = false;
  };

  /**
   * 언어 드랍다운리스트 클릭
   * @param languageCode 선택한 언어 코드
   */
  const handleLanguageClick = (languageCode: LocaleLanguage) => {
    i18n.locale.value = languageCode;
    isShown.value = false;
  };
</script>

<style scoped lang="scss">
  .utility__language {
    position: relative;
    .language__current {
      position: relative;
      display: flex;
      align-items: center;
      width: 11.7188vw;
      padding: 1.4925vw;
      .current__text {
        font-size: 1.4925vw;
        font-weight: 400;
        line-height: 2.0896vw;
        color: #fff;
        margin-right: 1.194vw;
        white-space: nowrap;
      }
    }

    .language__ul {
      position: absolute;
      bottom: 0;
      left: 0;
      min-width: 8.9552vw;
      background: #fff;
      border-radius: 0.5224vw;
      border: 0.0746vw solid #707070;
      z-index: 4;
      li {
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 1.3433vw 0 1.8657vw;
        height: 5.2239vw;
      }
      li + li {
        border-top: 0.0746vw solid #707070;
      }
      .current__text {
        font-size: 1.4925vw;
        font-weight: 400;
        line-height: 2.0896vw;
        margin-right: 1.194vw;
        white-space: nowrap;
      }
    }

    .language__backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(var(--vh, 1vh) * 100);
    }
  }
</style>
